/* ================================================================
   EYEGENIC — theme.js  v2.0
   Cursor · Nav scroll · Scroll reveal · Parallax
   Blob mouse drift · Hero tilt · Card tilt · Gallery switcher
   Smooth anchors
   ================================================================ */

(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────────── */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function onScroll(fn) {
    window.addEventListener('scroll', fn, { passive: true });
  }

  /* ── Run after DOM ready ──────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {

    /* 1. Custom cursor (fine-pointer devices only) */
    var cur = $('#cursor');
    var ring = $('#cursor-ring');
    if (cur && ring && window.matchMedia('(pointer: fine)').matches) {
      var mx = -200, my = -200, rx = -200, ry = -200;

      document.addEventListener('mousemove', function (e) {
        mx = e.clientX;
        my = e.clientY;
      });

      (function animCursor() {
        cur.style.left = mx + 'px';
        cur.style.top  = my + 'px';
        rx += (mx - rx) * 0.12;
        ry += (my - ry) * 0.12;
        ring.style.left = rx + 'px';
        ring.style.top  = ry + 'px';
        requestAnimationFrame(animCursor);
      })();

      $$('a, button, [role="button"]').forEach(function (el) {
        el.addEventListener('mouseenter', function () {
          cur.style.width = '20px'; cur.style.height = '20px';
          ring.style.width = '58px'; ring.style.height = '58px';
          ring.style.opacity = '0.22';
        });
        el.addEventListener('mouseleave', function () {
          cur.style.width = '10px'; cur.style.height = '10px';
          ring.style.width = '36px'; ring.style.height = '36px';
          ring.style.opacity = '0.45';
        });
      });
    }

    /* 2. Nav scroll state */
    var nav = $('#site-header');
    if (nav) {
      var updateNav = function () {
        nav.classList.toggle('scrolled', window.scrollY > 60);
      };
      onScroll(updateNav);
      updateNav();
    }

    /* 3. Scroll reveal */
    var revealEls = $$('.reveal');
    if (revealEls.length) {
      if ('IntersectionObserver' in window) {
        var revIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) e.target.classList.add('in');
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
        revealEls.forEach(function (el) { revIO.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('in'); });
      }
    }

    /* 4. Parallax */
    var parallaxEls = $$('.parallax');
    if (parallaxEls.length) {
      var doParallax = function () {
        var sy = window.scrollY;
        parallaxEls.forEach(function (el) {
          var speed = parseFloat(el.getAttribute('data-speed') || 0);
          var rect = el.getBoundingClientRect();
          var center = rect.top + rect.height / 2;
          var offset = (center - window.innerHeight / 2) * speed;
          el.style.transform = 'translateY(' + offset + 'px)';
        });
      };
      onScroll(doParallax);
      doParallax();
    }

    /* 5. Blob mouse parallax */
    var blobs = $$('.blob');
    if (blobs.length) {
      window.addEventListener('mousemove', function (e) {
        var fx = (e.clientX / window.innerWidth  - 0.5) * 28;
        var fy = (e.clientY / window.innerHeight - 0.5) * 28;
        blobs.forEach(function (b, i) {
          var f = (i + 1) * 0.4;
          b.style.transform = 'translate(' + (fx * f) + 'px,' + (fy * f) + 'px)';
        });
      });
    }

    /* 6. Hero product 3D tilt */
    var heroImg = $('#hero-product');
    if (heroImg) {
      var stack = heroImg.closest('.hero__img-stack');
      if (stack) {
        stack.addEventListener('mousemove', function (e) {
          var r = stack.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width  - 0.5) * 14;
          var y = ((e.clientY - r.top)  / r.height - 0.5) * -14;
          heroImg.style.transform = 'perspective(900px) rotateY(' + x + 'deg) rotateX(' + y + 'deg)';
          heroImg.style.transition = 'transform 0.12s ease';
        });
        stack.addEventListener('mouseleave', function () {
          heroImg.style.transform = '';
          heroImg.style.transition = '';
        });
      }
    }

    /* 7. Card tilt micro-interaction */
    $$('.cond-card, .testi-card, .use-card, .mode-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width  - 0.5) * 6;
        var y = ((e.clientY - r.top)  / r.height - 0.5) * -6;
        card.style.transform = 'translateY(-4px) perspective(600px) rotateY(' + x + 'deg) rotateX(' + y + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });

    /* 8. Product gallery image switcher */
    var thumbBtns = $$('.product__thumb[data-img]');
    var mainImg = $('#product-main-img');
    if (thumbBtns.length && mainImg) {
      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          mainImg.style.opacity = '0';
          mainImg.style.transition = 'opacity 0.22s ease';
          setTimeout(function () {
            mainImg.src = btn.getAttribute('data-img');
            mainImg.style.opacity = '1';
          }, 210);
          thumbBtns.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
        });
      });
    }

    /* 9. Smooth anchor scrolling */
    $$('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          var offset = 80;
          var top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

  }); // end DOMContentLoaded

})();

/* ================================================================
   MOBILE MENU
   ================================================================ */
(function () {
  var menuBtn     = document.getElementById('mobile-menu-btn');
  var menu        = document.getElementById('mobile-menu');
  var overlay     = document.getElementById('mobile-menu-overlay');
  var closeBtn    = document.getElementById('mobile-menu-close');
  var menuLinks   = menu ? menu.querySelectorAll('.mobile-menu__link, .mobile-menu__cta') : [];

  if (!menuBtn || !menu) return;

  function openMenu() {
    menu.hidden = false;
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
  }

  function closeMenu() {
    menu.hidden = true;
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    menuBtn.focus();
  }

  menuBtn.addEventListener('click', openMenu);
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay && overlay.addEventListener('click', closeMenu);

  menuLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.hidden) closeMenu();
  });
})();
